module.exports = __webpack_public_path__ + "visa.svg?476c7f5c41c068ffa841097bf41cd03c";